import template from './user-messages.html';
import userMessagesController from './user-messages.controller';
import './user-messages.styl';

let userMessagesComponent = {
  restrict: 'E',
  bindings: {
    userId: '<'
  },
  template,
  controller: userMessagesController,
  controllerAs: 'vm'
};

export default userMessagesComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-messages/user-messages.component.js
 **/